module.exports = "<span data-ng-message=maxlength>* No more than 5,000 characters are allowed </span> ";